import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  breadcrumb?: Crumb[];
}

export default function PageHeader({
  eyebrow,
  title,
  description,
  breadcrumb,
}: PageHeaderProps) {
  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-8 pt-28 md:pt-36 pb-10 md:pb-14">
        {breadcrumb && breadcrumb.length > 0 && (
          <nav className="flex items-center flex-wrap gap-2 text-xs text-secondary-500 mb-5">
            {breadcrumb.map((crumb, index) => (
              <span key={crumb.label} className="flex items-center gap-2">
                {crumb.path ? (
                  <Link
                    to={crumb.path}
                    className="hover:text-accent-600 transition-colors"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-foreground-700">{crumb.label}</span>
                )}
                {index < breadcrumb.length - 1 && (
                  <i className="ri-arrow-right-s-line" />
                )}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && (
          <span className="inline-block text-xs font-label tracking-[0.25em] uppercase text-accent-600 mb-3">
            {eyebrow}
          </span>
        )}
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
          {title}
        </h1>
        {description && (
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}